var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { TextField, makeStyles } from "@material-ui/core";
import { typography } from "../../shared/theme";
export const FTLTextField = React.forwardRef((_a, ref) => {
    var { size, InputProps = {}, variant = "outlined" } = _a, other = __rest(_a, ["size", "InputProps", "variant"]);
    const classes = useStyles();
    return (React.createElement(TextField, Object.assign({ classes: {
            root: classes.root,
        }, inputRef: ref, InputLabelProps: {
            variant: "standard",
            shrink: true,
            classes: {
                root: classes.label,
                asterisk: classes.asterisk,
                error: classes.error,
            },
        }, FormHelperTextProps: {
            classes: {
                root: classes.helperText,
                disabled: classes.helperTextDisabled,
                error: classes.helperTextError,
            },
        }, InputProps: Object.assign({ classes: {
                root: `${classes.inputRoot} ${size === "small" && classes.small}`,
                error: classes.error,
                focused: classes.inputFocused,
                disabled: classes.disabled,
            } }, InputProps), variant: variant }, other)));
});
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        "& .MuiInputAdornment-root": {
            zIndex: 1,
        },
    },
    label: Object.assign(Object.assign({ position: "static", marginBottom: "8px", transform: "none" }, theme.typography.h5), { color: `${theme.palette.text.tertiary} !important`, whiteSpace: "nowrap" }),
    helperText: {
        marginTop: theme.spacing(1),
        color: "#627084",
        marginLeft: 0,
        marginRight: 0,
    },
    helperTextDisabled: {
        color: "#627084",
    },
    helperTextError: {
        color: theme.palette.text.error,
    },
    inputRoot: {
        "& > input": Object.assign({ padding: "11.7px 8px", zIndex: 1, outline: "none", borderRadius: 4, "&:-webkit-autofill": {
                transitionDelay: "9999s",
                transitionProperty: "background-color, color",
            } }, typography.unsupportedSemanticTags.listItemText),
        "&.MuiInput-root": {
            paddingBottom: 8,
            height: 40,
        },
        "& > input[readonly='']": {
            backgroundColor: theme.palette.textField.disabled,
            cursor: "default",
            pointerEvents: "none",
        },
        "&.MuiInput-underline::before": {
            borderBottom: "1px solid #EBEDF0 !important",
        },
        "&.MuiInput-underline::after": {
            borderBottom: "none",
        },
        "& fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.border.textField,
        },
        "&:not($inputFocused):not($error):hover > fieldset": {
            backgroundColor: theme.palette.textField.hover,
            borderColor: theme.palette.border.textField,
        },
        "&:not($inputFocused) > fieldset": {
            backgroundColor: theme.palette.textField.inactive,
        },
        "& > fieldset": {
            top: 0,
        },
        "& > fieldset > legend": {
            display: "none",
        },
        "&.MuiInputBase-adornedEnd": {
            paddingRight: "0",
            "& div": {
                position: "absolute",
                right: 4,
            },
            "& button": {
                padding: "0",
            },
            "& svg": {
                zIndex: 1,
            },
        },
    },
    small: {
        "& > input": {
            padding: "7.7px",
        },
        "& > fieldset": {
            top: 0,
        },
    },
    error: {
        "& > fieldset": {
            borderWidth: "2px",
            borderColor: `${theme.palette.border.textFieldError} !important`,
        },
    },
    disabled: {
        backgroundColor: theme.palette.textField.disabled,
        "& > fieldset": {
            border: "none",
        },
    },
    inputFocused: {
        "&:not($error) > fieldset": {
            background: theme.palette.textField.focus,
            borderColor: `${theme.palette.border.focus} !important`,
        },
    },
    asterisk: { color: theme.palette.text.error },
}));
//# sourceMappingURL=index.js.map